module.exports = __webpack_public_path__ + "img/engineering.f2073796.svg";